import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Box,
} from '@mui/material';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import PropTypes from 'prop-types';

function TestimonialSettingsDialog({ open, onClose, facilityId = '' }) {
  const [notificationEmails, setNotificationEmails] = useState([]);
  const [ratingEmails, setRatingEmails] = useState([]);

  useEffect(() => {
    if (!open || !facilityId) return;

    (async () => {
      const ref = doc(db, 'testimonialSettings', facilityId);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setNotificationEmails(data.notificationEmails || []);
        setRatingEmails(data.ratingEmails || []);
      } else {
        setNotificationEmails([]);
        setRatingEmails([]);
      }
    })();
  }, [open, facilityId]);

  const handleSave = async () => {
    if (!facilityId) return onClose();

    const ref = doc(db, 'testimonialSettings', facilityId);
    await setDoc(ref, { notificationEmails, ratingEmails }, { merge: true });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Manage Testimonial Settings
        {facilityId && ` - ${facilityId}`}
      </DialogTitle>

      <DialogContent>
        {facilityId ? (
          <>
            <Box sx={{ my: 2 }}>
              <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={notificationEmails}
                onChange={(e, v) => setNotificationEmails(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Notification Emails"
                    placeholder="Enter email(s) to notify on new testimonials"
                  />
                )}
              />
            </Box>
            <Box sx={{ my: 2 }}>
              <Autocomplete
                multiple
                freeSolo
                options={[]}
                value={ratingEmails}
                onChange={(e, v) => setRatingEmails(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Allowed Rating Emails"
                    placeholder="Enter email(s) allowed to rate testimonials"
                  />
                )}
              />
            </Box>
          </>
        ) : (
          <Box sx={{ my: 3 }}>
            <em>Please select a building first.</em>
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" disabled={!facilityId}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

TestimonialSettingsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  facilityId: PropTypes.string,
};

export default TestimonialSettingsDialog;
